
import {
    SIDEMENUSTATUS,
  } from "./type";

  export function SideMenuToggle(status) {
    return (dispatch, getState) => {
      dispatch({ type:SIDEMENUSTATUS, payload:status});
  
    }
  }
 